import { FC } from 'react';
import { useForm } from 'react-hook-form';
import { TsForm } from '../../components/form/Form';
import { SubmitCancelButtons } from '../../components/form/SubmitCancelButtons';
import { TextFieldWithOptionalLabel } from '../../components/form/TextInput';
import { handleMutationResult } from '../../helpers/toastHelper';
import { useUpdateDeviceMutation } from '../../services/gql/graphql.generated';
import strings from './devices.translations';

interface EditDeviceFormProps {
  id: string;
  name: string;
  locationId: number;
  onClose: () => void;
}

interface EditDeviceFields {
  name: string;
}

export const EditDeviceForm: FC<EditDeviceFormProps> = ({ id, name, locationId, onClose }) => {
  const methods = useForm<EditDeviceFields>({ defaultValues: { name } });

  const [{ fetching }, updateDevice] = useUpdateDeviceMutation();

  const onSubmit = async (values: EditDeviceFields) => {
    const result = await updateDevice({
      args: {
        name: values.name,
        id: id,
        locationId
      }
    });

    await handleMutationResult(result, {
      successMessage: "Device settings saved.",
      errorMessage: "Unable to edit device.",
      onSuccess: onClose
    });
  };

  return (
    <TsForm methods={methods} onSubmit={onSubmit}>
      <div className="flex flex-col space-y-5 xl:w-96 mt-3">
        <TextFieldWithOptionalLabel
          id="name"
          name="name"
          title={strings.editDeviceModal.nameField}
          validationMessage={strings.editDeviceModal.nameRequired}
          required
          placeholder={strings.editDeviceModal.namePlaceholder}
          value={methods.watch('name') || ''}
          onChange={values => methods.setValue('name', values)}
        />
        <div className="flex items-center justify-end gap-3">
          <SubmitCancelButtons
            onComplete={() => {}}
            loading={fetching}
            submitText={strings.common.save}
          ></SubmitCancelButtons>
        </div>
      </div>
    </TsForm>
  );
};
